import BarChart from "@/modules/Dashboards/AdminDashboard/components/Charts/Bar/BarChart.vue";
import DoughnutChart from "@/modules/Dashboards/AdminDashboard/components/Charts/Doughnut/DoughnutChart.vue";
import HorizontalBarChart from "@/modules/Dashboards/AdminDashboard/components/Charts/HorizontalBar/HorizontalBarChart.vue";
import LineChart from "@/modules/Dashboards/AdminDashboard/components/Charts/Line/LineChart.vue";
import PieChart from "@/modules/Dashboards/AdminDashboard/components/Charts/Pie/PieChart.vue";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { CHART_TYPES } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import draggable from "vuedraggable";
import ChartTypeSelection from "./ChartTypeSelection/ChartTypeSelection.vue";
import { CrudChartRenderData } from "@/modules/Dashboards/AdminDashboard/models/CrudChartRenderData";
import { CHART_EVENTS } from "./constants/CrudChartConstants";

Vue.use(Vuetify);

@Component({
  name: "CrudChart",
  components: {
    draggable,
    LineChart,
    PieChart,
    DoughnutChart,
    BarChart,
    HorizontalBarChart,
    ChartTypeSelection
  }
})
export default class CrudChart extends Vue {
  @Prop({ default: [] })
  private crudChartRenderData!: CrudChartRenderData;
  @Prop() private propChartType!: string;

  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;

  TOOLTIP = FORM_TEMP_CONSTANTS.TOOLTIP;
  CHAR_TYPES = CHART_TYPES;

  chartType: string = CHART_TYPES[2].value;

  mounted() {
    if (this.propChartType) {
      this.chartType = this.propChartType;
    }
  }

  changeChartType(chartType: string) {
    this.chartType = chartType;
  }

  chartClick(label: string) {
    this.$emit(CHART_EVENTS.CLICK, label);
  }

  chartClickOut() {
    this.$emit(CHART_EVENTS.CLICK_OUT);
  }
}
